import { useContext } from 'react';
import FiltersContext from './context/FiltersContext';
import CustomersEvidenceFiltersContextV2 from '../../Customer360V2/components/filtersv2/CustomersEvidenceFiltersContext';

/**
 * Helper hook that tries CustomersEvidenceFiltersContext first (for Customer360),
 * and falls back to FiltersContext if not available.
 * This allows filter components to work in both contexts.
 */
export const useFiltersContextHelper = () => {
  // Try V2 Customer360 context first, then fall back to regular FiltersContext
  const customerContextV2 = useContext(CustomersEvidenceFiltersContextV2 as any);
  const regularContext = useContext(FiltersContext);

  const hasRequiredFns = (ctx: any) =>
    ctx &&
    typeof ctx.setActiveFilters === 'function' &&
    typeof ctx.setChildFiltersValue === 'function' &&
    typeof ctx.setCheckedComponents === 'function';

  if (hasRequiredFns(customerContextV2)) {
    return customerContextV2;
  }
  if (hasRequiredFns(regularContext)) {
    return regularContext;
  }

  // Safe no-op fallback to avoid runtime crashes if no provider is mounted
  const noop = (): void => { return; };
  return {
    openedMenuType: null,
    setOpenedMenuType: noop,
    activeFilters: [],
    setActiveFilters: noop,
    selectedParentFilter: null,
    setSelectedParentFilter: noop,
    checkedComponents: {},
    setCheckedComponents: noop,
    childFiltersValue: {},
    setChildFiltersValue: noop,
    parentQuery: '',
    setParentQuery: noop,
    childQuery: undefined,
    setChildQuery: noop,
    operator: undefined,
    setOperator: noop,
    numberValue: undefined,
    setNumberValue: noop,
    rangeDates: undefined,
    setRangeDates: noop,
    subPageKey: undefined,
    editMode: false,
    setEditMode: noop,
  } as any;
};

